module.exports = __webpack_public_path__ + "img/Streeme-start_spinner.35418c.svg";